import { QuestionStatus } from '@exam-management/graphql';
import { LabelColor } from '@shared/components';

export const QCONTENT_COLOR_STATUS = {
  [QuestionStatus.InDevelopment]: LabelColor.INFO,
  [QuestionStatus.InReview]: LabelColor.INFO,
  [QuestionStatus.PreDraft]: LabelColor.INFO,
  [QuestionStatus.Draft]: LabelColor.INFO,
  [QuestionStatus.Published]: LabelColor.SUCCESS,
  [QuestionStatus.Unpublished]: LabelColor.WARNING,
  [QuestionStatus.Disabled]: LabelColor.GREY,
};

export const QCONTENT_STATUS_TEXT = {
  [QuestionStatus.InDevelopment]: 'Question Creation',
  [QuestionStatus.InReview]: 'Question Review',
  [QuestionStatus.PreDraft]: 'Pre-Draft',
  [QuestionStatus.Draft]: 'Draft',
  [QuestionStatus.Published]: 'Published',
  [QuestionStatus.Unpublished]: 'Pending',
  [QuestionStatus.Disabled]: 'Disabled',
};
